import React from "react";
import { LABELS } from "@/common/constants/constants";
import { v4 as uuidv4 } from "uuid";
import { IRelatedJobs } from "@/common/types/Types";
import Link from "next/link";

import styles from "./JobsListSearchSection.module.scss";

interface IProps {
  relatedJobs: IRelatedJobs[];
}

const JobsListSearchSection = ({ relatedJobs }: IProps) => {
  return (
    <div className={styles.wrapper}>
      <h3>{LABELS.RELATED_JOBS}</h3>
      <div className={styles.keywordsWrapper}>
        {(relatedJobs || [])?.map((item) => {
          return (
            <Link
              href={{
                pathname: "/jobs",
                query: {
                  keyword: item.value,
                },
              }}
              key={uuidv4()}
            >
              <div className={styles.keyword}>{item.value}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default JobsListSearchSection;
